import React from 'react';
import { RouteProps, Navigate } from 'react-router-dom';
import { UserType } from 'utils/api/users';
import { userRoles } from 'utils/userRoles';

import { useApp } from 'App/index';

interface Props {
  Component: React.ComponentType;
  requiredRole?: UserType[];
  /**
   * When true, the route is only accessible to admins or to users whose
   * profile has `has_resql_expert_schools === true`. The flag is set
   * server-side based on the school's `resql_expert_enabled` toggle.
   */
  requireResqlExpert?: boolean;
}

const PrivateRoute: React.FC<Props & RouteProps> = ({ Component, requiredRole, requireResqlExpert }) => {
  const [{ isLoggedIn, profile }] = useApp();

  const hasRoleAccess = !requiredRole?.length || (profile && requiredRole.includes(profile.role));

  const hasResqlExpertAccess =
    !requireResqlExpert || (profile && (profile.role === userRoles.admin || profile.has_resql_expert_schools === true));

  return isLoggedIn && hasRoleAccess && hasResqlExpertAccess ? (
    <Component />
  ) : (
    <Navigate to="/app" />
  );
};

export default PrivateRoute;
